import React, { useCallback, useRef, useState, useEffect, useMemo } from 'react'


import { useTranslation } from 'src/utils/i18n'

import PerfectScrollbar from 'react-perfect-scrollbar'
import Button from '@mui/material/Button'

import styles from './index.module.scss'

import Image from 'next/image'

import { GoogleMap, withScriptjs, withGoogleMap, Circle, Polyline, Marker, InfoWindow } from 'react-google-maps'
import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer'

import Card from '@mui/material/Card'
import { Icon } from '@iconify/react'
import dayjs from 'dayjs'

import { Pagination, Spin, Tabs, Timeline, DatePicker, Modal } from 'antd'

const { RangePicker } = DatePicker

// request
import axios from 'axios'

import { getLocalAndroidAll } from 'src/@api/dashboard'

import Head from 'next/head'
import { useRouter } from 'next/router'
import { useDispatch } from 'react-redux'
import { setCurrentTab } from 'src/store/apps/Common'
import RangePickerBox from 'src/components/RangePickerBox'
import { useDeviceScopedInit } from 'src/hooks/useDeviceScopedInit'
import ContentLoading from 'src/components/ContentLoading'

// https://maps.googleapis.com/maps/api/geocode/json?latlng=-31.09426446332877,150.9346199539215&key=AIzaSyCkRXX3doVacVKRHM-oECpLRgC0LNtVkxw

const POSITION = []

const runScopedTask = task => {
  task?.catch(error => {
    if (error?.code !== 'ERR_CANCELED' && error?.name !== 'CanceledError') console.error(error)
  })
}

function GPS() {
  const { query } = useRouter()
  const { t } = useTranslation('common')
  let Basic = window.localStorage.getItem('Basic')
  Basic = Basic == null || Basic == 0 ? true : false

  let Advanced = window.localStorage.getItem('currentDevice')
  Advanced = Advanced == null || Advanced != '{}' ? false : true

  const scopeRef = useRef(null)
  const reloadRef = useRef(null)
  const advancedGpsRef = useRef(null)
  const setLocationRef = useRef(null)

  const dispatch = useDispatch()

  // 查询设备
  const [bgdata, setBgdata] = useState(0)

  const [mapdata, setMapdata] = useState(null)

  const [mapCenter, setMapCenter] = useState({ lat: 40.7143528, lng: -74.0059731 })

  const [zoom, setZoom] = useState(15)

  const [positiondata, setPositiondata] = useState([])
  const [mapPositiondata, setMapPositiondata] = useState([])

  const [preViewImageOpen, setPerViewImageOpen] = useState(false)
  const [preViewImageUrl, setPerViewImageUrl] = useState('')
  const [isLoading, setIsLoading] = useState(true) //正在加载获取数据

  // 移动端选择
  const [switchTags, setSwitchTags] = useState('1')

  // 初始值设置为不是移动端
  const [isMobile, setIsMobile] = useState(false)
  const ua = navigator.userAgent.toLowerCase()
  const agents = ['iphone', 'ipad', 'ipod', 'android', 'linux', 'windows phone']

  const isMobileFun = () => {
    for (let i = 0; i < agents.length; i++) {
      if (ua.indexOf(agents[i]) !== -1) {
        setIsMobile(true)
      }
    }
  }

  // 获取地理位置
  let location = async (latitude, longitude, signal) => {
    try {
      let result = await axios({
        url: `${process.env.NEXT_PUBLIC_LONGITUDE_KEY}?latitude=${latitude}&longitude=${longitude}`,
        method: 'get',
        signal
      })

      let location = `${result.data.countryName} ${result.data.city} ${result.data.locality}`

      return `${location}`
    } catch (error) {
      return ''
    }
  }

  useEffect(() => {
    const title = t('GPS location')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  const [page, setPage] = useState(1)

  const [total, setTotal] = useState(0)

  const [flag, setFlag] = useState(false)

  // 分页处理
  const onChangePage = async hide => {
    setPage(page + 1)
  }

  // 获取基础gps
  let basicGps = async (page, pageSize, scope = scopeRef.current) => {
    if (!scope) return
    const { context, signal, isCurrent } = scope
    setFlag(true)

    let params = {
      category: 'LOCATION',
      offset: page,
      limit: pageSize,
      deviceUdid: context?.username || ''
    }

    startTime == '' ? null : (params.startTime = dayjs(dayjs(startTime).format('YYYY-MM-DD 00:00:00')).unix() * 1000)
    endTime == '' ? null : (params.endTime = dayjs(dayjs(endTime).format('YYYY-MM-DD 23:59:59')).unix() * 1000)

    let response = await getLocalAndroidAll({
      username: JSON.parse(localStorage.getItem('userData') || '{}')?.data?.email || '',
      params
    }, { signal })
    if (!isCurrent()) return
    let result = response.data.contents
    if (result != null) {
      result = positiondata.concat(response.data.contents)
      setTotal(response.data.totalCount)
    }
    if (result?.length > 0) {
      setMapCenter({
        lat: result[0].latitude,
        lng: result[0].longitude
      })
    }

    let newArr = result

    if (result != null) {
      localStorage.removeItem('gpsLocations')

      // 先落点位并结束首屏 loading，地址反查异步补齐（避免 ContentLoading 卡整卡）
      let positionDataList = result.map((item, i) => ({
        ...item,
        id: i + 1,
        lat: item.latitude,
        lng: item.longitude
      }))
      setFlag(false)
      setPositiondata(positionDataList)
      setMapPositiondata(positionDataList)
      setMapdata(result[0])
      setIsLoading(false)

      for (let i = 0; i < newArr.length; i++) {
        if (typeof newArr[i].position == 'undefined') {
          newArr[i].position = await location(`${result[i].latitude}`, `${result[i].longitude}`, signal)
          if (!isCurrent()) return

          // newArr[i].position = '50'
        }

        newArr[i].id = i + 1
      }

      positionDataList = result.map(item => {
        return {
          ...item,
          lat: item.latitude,
          lng: item.longitude
        }
      })

      setPositiondata(positionDataList)
      setMapPositiondata(positionDataList)

      // 未使用此属性
      // setBgdata(positionDataList[0].id)
    } else {
      setFlag(false)
      setIsLoading(false)
    }
  }

  // 获取高级gps
  let advancedGps = async (page, pageSize, scope = scopeRef.current) => {
    if (!scope) return
    const { context, signal, isCurrent } = scope
    setFlag(true)

    let params = {
      category: 'LOCATION',
      offset: page,
      limit: pageSize,
      deviceUdid: context?.username || ''
    }

    startTime == '' ? null : (params.startTime = dayjs(dayjs(startTime).format('YYYY-MM-DD 00:00:00')).unix() * 1000)
    endTime == '' ? null : (params.endTime = dayjs(dayjs(endTime).format('YYYY-MM-DD 23:59:59')).unix() * 1000)

    let response = await getLocalAndroidAll({
      username: JSON.parse(localStorage.getItem('userData') || '{}')?.data?.email || '',
      params
    }, { signal })

    if (!isCurrent()) return

    setFlag(false)

    let result = response.data.contents

    if (result != null) {
      result = positiondata.concat(response.data.contents)

      setTotal(response.data.totalCount)
    }

    if (result?.length > 0) {
      setMapCenter({
        lat: result[0].latitude,
        lng: result[0].longitude
      })
    }

    // let newArr = result.filter((obj, index, self) => {
    //   console.log(obj, index, self, 456)

    //   return index === self.findIndex(o => o.timeStamp === obj.timeStamp)
    // })
    let newArr = result

    if (result != null) {
      localStorage.removeItem('gpsLocations')

      // 先落点位并结束首屏 loading，地址反查异步补齐（避免 ContentLoading 卡整卡）
      let positionDataList = newArr.map((item, i) => ({
        ...item,
        id: i + 1,
        lat: item.latitude,
        lng: item.longitude
      }))
      setPositiondata(positionDataList)
      setMapPositiondata(positionDataList)
      setMapdata(result[0])
      setIsLoading(false)

      for (let i = 0; i < newArr.length; i++) {
        if (typeof newArr[i].position == 'undefined') {
          newArr[i].position = await location(`${result[i].latitude}`, `${result[i].longitude}`, signal)
          if (!isCurrent()) return

          // newArr[i].position = 10
        }

        newArr[i].id = i + 1
      }

      positionDataList = newArr.map(item => {
        return {
          ...item,
          lat: item.latitude,
          lng: item.longitude
        }
      })

      setPositiondata(positionDataList)
      setMapPositiondata(positionDataList)

      // 未使用此属性
      // setBgdata(positionDataList[0].id)
    } else {
      setIsLoading(false)
    }
  }

  // 选择日期
  const [startTime, setStartTime] = useState('')
  const [endTime, setEndTime] = useState('')

  useEffect(() => {
    setPositiondata([])
    runScopedTask(advancedGpsRef.current?.(0, 30, scopeRef.current))
  }, [startTime])

  const setLocation = async (data, scope = scopeRef.current) => {
    if (!scope) return

    // 判断是要不要获取高级版gps
    if (Advanced) {
      if (page === 1 && positiondata.length === 0) {
        //首次加载10
        await basicGps((page - 1) * 30, 10, scope)
      } else if (positiondata.length === 10) {
        //首次获取完 再取20
        await basicGps((page - 1) * 30, 20, scope)
      } else {
        //手动点击
        await basicGps((page - 1) * 30, 30, scope)
      }
    } else {
      if (page === 1 && positiondata.length === 0) {
        //首次加载10
        await advancedGps((page - 1) * 30, 10, scope)
      } else if (positiondata.length === 10) {
        //首次获取完 再取20
        await advancedGps((page - 1) * 30, 20, scope)
      } else {
        //手动点击
        await advancedGps((page - 1) * 30, 30, scope)
      }
    }
  }

  advancedGpsRef.current = advancedGps
  setLocationRef.current = setLocation

  reloadRef.current = scope => {
    runScopedTask(setLocation(undefined, scope))
    isMobileFun()
  }

  // 设备切换时重置地图与轨迹数据并重新拉数
  useDeviceScopedInit(
    useCallback((_, scope) => {
      scopeRef.current = scope
      setPage(1)
      setTotal(0)
      setFlag(false)
      setPositiondata([])
      setMapPositiondata([])
      setMapdata(null)
      setStartTime('')
      setEndTime('')
      setIsLoading(true)
      reloadRef.current?.(scope)
    }, [])
  )

  //首次取完 再取20（只依赖条数，避免地址反查二次 set 重复拉数）
  useEffect(() => {
    if (positiondata.length === 10) {
      runScopedTask(setLocationRef.current?.())
    }
  }, [positiondata.length])

  const [mapRef, setMapRef] = useState('')

  const onMapLoad = map => {
    const bounds = new window.google.maps.LatLngBounds()

    for (let i = 0; i < positiondata.length; i++) {
      bounds.extend(positiondata[i])
    }

    map.fitBounds(bounds)
  }

  useEffect(() => {
    if (page > 1) runScopedTask(setLocationRef.current?.(undefined, scopeRef.current))
  }, [page])

  // 检测gps地图加载是否完毕
  const [isLeafletLoaded, setIsLeafletLoaded] = useState(false)
  useEffect(() => {
    let active = true
    let timerId
    const checkLeafletLoaded = () => {
      if (!active) return
      if (typeof L !== 'undefined') {
        setIsLeafletLoaded(true)
      } else {
        timerId = setTimeout(checkLeafletLoaded, 100)
      }
    }
    checkLeafletLoaded()

    return () => {
      active = false
      if (timerId) clearTimeout(timerId)
    }
  }, [])

  useEffect(() => {
    if (isLeafletLoaded && switchTags == '1') {
      if (mapPositiondata.length !== 0) return

      var mapContainer = document.getElementById('LeafletMap')
      if (mapContainer) {
        var parent = mapContainer.parentNode
        parent.removeChild(mapContainer)
      }

      // 获取父元素
      var leafletContainer = document.getElementById('leaflet')

      if (leafletContainer) {
        // 创建子元素 div
        var mapDiv = document.createElement('div')
        mapDiv.id = 'LeafletMap'

        // 将子元素添加到父元素中
        leafletContainer.appendChild(mapDiv)
      }

      // 创建地图容器并初始化地图
      const leafletMap = L.map('LeafletMap').setView([51.505, -0.09], 13)
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19
      }).addTo(leafletMap)

      return () => leafletMap.remove()
    }
  }, [isLeafletLoaded, mapPositiondata.length, switchTags])

  useEffect(() => {
    if (isLeafletLoaded && switchTags == '1') {
      if (mapPositiondata.length !== 0) {
        var mapContainer = document.getElementById('LeafletMap')
        if (mapContainer) {
          var parent = mapContainer.parentNode
          parent.removeChild(mapContainer)
        }

        // 获取父元素
        var leafletContainer = document.getElementById('leaflet')

        if (leafletContainer) {
          // 创建子元素 div
          var mapDiv = document.createElement('div')
          mapDiv.id = 'LeafletMap'

          // 将子元素添加到父元素中
          leafletContainer.appendChild(mapDiv)
        }

        // 创建地图容器并初始化地图

        const leafletMap = L.map('LeafletMap').setView(
          [mapPositiondata[0].lat, mapPositiondata[0].lng],
          mapPositiondata.length == 1 ? 18 : 13
        )
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19
        }).addTo(leafletMap)

        /* 坐标icon */
        const customIcon = L.icon({
          iconUrl: 'https://demo.mobilespy.io/assets/images/icons/map-marker.svg',
          iconSize: [50, 50],
          iconAnchor: [16, 32]
        })

        // 创建一个MarkerClusterGroup对象，自定义聚合图标
        const markerCluster = new L.MarkerClusterGroup({
          iconCreateFunction: function (cluster) {
            var childCount = cluster.getChildCount()

            var customIconHtml =
              '<div class="custom-cluster-icon">' +
              '<img src="/images/gps/m2.png" class="custom-cluster-icon">' +
              '<div class="cluster-count">' +
              childCount +
              '</div>' +
              '</div>'

            return L.divIcon({
              html: customIconHtml,
              className: 'custom-cluster-wrapper', // 自定义样式的类名
              iconSize: [50, 50]
            })
          }
        })

        // 添加标记到MarkerClusterGroup
        let coordinates = []

        // 每个标记的弹出框内容
        let popupContents = []

        mapPositiondata.forEach(item => {
          coordinates.push([item.lat, item.lng])
        })

        mapPositiondata.forEach(item => {
          popupContents.push(item.position)
        })

        // 遍历坐标数组并添加标记到MarkerClusterGroup
        coordinates.forEach(function (coord, index) {
          var marker = L.marker(coord, { icon: customIcon })

          // 为每个标记添加点击事件和不同的弹出框内容
          marker.bindPopup(popupContents[index])

          marker.on('click', function () {
            leafletMap.setView(coord, 20) // 设置视图以当前坐标为中心，缩放级别为16（根据需要进行调整）
          })

          markerCluster.addLayer(marker)
        })

        leafletMap.addLayer(markerCluster)

        // 获取标记的坐标
        var latlngs = coordinates.map(function (coord) {
          return L.latLng(coord[0], coord[1])
        })

        // 自定义连线的样式
        var customLineStyle = {
          color: 'blue', // 线的颜色
          weight: 2, // 线的宽度
          opacity: 0.7 // 线的不透明度
        }

        // 创建Polyline对象并将其添加到地图，应用自定义样式
        L.polyline(latlngs, customLineStyle).addTo(leafletMap)

        // 为MarkerClusterGroup添加点击事件
        markerCluster.on('clusterclick', function (event) {
          // 获取点击的聚合的中心点坐标
          var clusterCenter = event.latlng

          // 放大地图到最大缩放级别
          leafletMap.setView(clusterCenter, leafletMap.getMaxZoom())
        })

        // 为MarkerClusterGroup添加点击事件

        return () => leafletMap.remove()
      }
    }
  }, [isLeafletLoaded, mapPositiondata, switchTags])

  const indexMarkers = row => {
    setMapPositiondata([row])
    if (isMobile) {
      setSwitchTags('1')
    }
  }

  const GpsList = () => {
    return (
      <div className='relative w-[40%] Mlg:w-full Bxl:h-[calc(var(--vh2)*100-158px)] Bxls:Headers5:h-[calc(var(--vh2)*100-213px)] Header5:big:h-[calc(var(--vh2)*100-278px)] bigs:h-[calc(var(--vh2)*100-338px)] overflow-auto items-center  border-[#e6e7ec] border-r-[1px] tb-2 gps-time-line'>
        <div className='mt-2' style={{ padding: '10px', position: 'relative' }}>
          {/* <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Pagination simple current={page} total={total} onChange={onChangePage} />
          </div>

          <div style={{ height: '26px' }}></div> */}
          {/* <PerfectScrollbar
            onYReachEnd={container => {
              console.log(22313)

              onChangePage()
            }}
          > */}
          <Timeline
            mode={'left'}
            items={positiondata.map(item => {
              return {
                label: (
                  <div>
                    <p style={{ color: '#6F6F6F', fontSize: '13px' }}>{dayjs(item.timeStamp).format('YY-MM-DD')}</p>
                    <p style={{ color: '#6F6F6F', fontSize: '13px' }}>{dayjs(item.timeStamp).format('h:mm a')}</p>
                  </div>
                ),
                children: (
                  <div
                    onClick={() => indexMarkers(item)}
                    style={{
                      // backgroundColor: item.id === bgdata ? '#EDEFF5' : '',
                      cursor: 'pointer',
                      borderRadius: '10px',
                      padding: '10px',
                      paddingTop: '0px'
                    }}
                  >
                    <p style={{ marginTop: '10px' }}>
                      <span style={{}}>{item.position}</span>
                    </p>
                    <p style={{ marginTop: '8px', color: '#6F6F6F', fontSize: '13px' }}>
                      GPS:
                      <span style={{ marginLeft: '4px' }}>
                        {item.lat.toFixed(6)},{item.lng.toFixed(6)}
                      </span>
                    </p>

                    {item.positionType == 'exif' ? (
                      <p style={{ marginTop: '8px', display: 'flex' }}>
                        <Image
                          onClick={e => {
                            setPerViewImageOpen(true)

                            setPerViewImageUrl('https://cos.spyx.com/' + item.sourceRefThumb)
                          }}
                          src={
                            item.sourceRefThumb == ''
                              ? 'https://cos.spyx.com/' + item.sourceRef
                              : 'https://cos.spyx.com/' + item.sourceRefThumb
                          }
                          width={60}
                          height={60}
                          alt='img'
                          style={{}}
                        ></Image>
                      </p>
                    ) : null}
                  </div>
                )
              }
            })}
          />
          {/* </PerfectScrollbar> */}

          {flag ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Spin />
            </div>
          ) : null}

          {!flag && (positiondata.length > 0 || isLoading) ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '20px 0' }}>
              <Button onClick={onChangePage}>{t('load more')}</Button>
            </div>
          ) : null}
        </div>
        {(positiondata.length > 0 || isLoading) ||
          <div className='text-center px-3 absolute inset-0 top-[-20%] flex justify-center items-center'>
            {t('It appears theres no data to show here yet')}<br />
            {t('If data exists it may take up to 1 hour to download and appear')}<br />
            {t('We suggest checking back in a little while')}
          </div>}
      </div>
    )
  }

  return (
    <>
      <Card className='relative'>
        {isLoading && positiondata.length === 0 ? (
          <div className='absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]'>
            <ContentLoading />
          </div>
        ) : null}
        <div className='lg:flex lg:flex-col Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)]'>
          {!Advanced ? (
            <div className='flex justify-between items-center px-[14px] pt-[15px]'>
              <div className='flex items-center'>
                {/* <Select
                  className='w-[158px] h-[36px]'
                  onChange={e => {
                    setPositiondata([])
                    setMapPositiondata([])

                    setSelectGeographicLocationId(e)
                    setPage(1)

                    advancedGps(0, 30)
                  }}
                  placeholder={t('Choose a device')}
                  options={geographicLocation}
                /> */}
                <div className='flex-1'>
                  <div className='mr-[10px]'>
                    <RangePickerBox
                      value={[startTime, endTime]}
                      onChange={e => {
                        if (e && e.length === 2) {
                          console.log(e)
                          setStartTime(e[0])
                          setEndTime(e[1])
                        } else {
                          setStartTime(null)
                          setEndTime(null)
                        }
                        setPositiondata([])
                        setMapPositiondata([])
                      }}
                      onClear={() => {
                        setStartTime(null)
                        setEndTime(null)
                        setPositiondata([])
                        setMapPositiondata([])
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='w-[96px] h-[36px] flex rounded-[18px] bg-[#EAEAEA] p-[2px] lg:hidden'>
                <div
                  className='flex-1 flex justify-center items-center rounded-[15px]'
                  style={{ backgroundColor: switchTags == 1 ? '#FFF' : '' }}
                  onClick={() => {
                    setSwitchTags(1)
                  }}
                >
                  <Image
                    src={switchTags == 1 ? '/images/gps/gps-active.svg' : '/images/gps/gps.svg'}
                    width={24}
                    height={24}
                    alt='date'
                  />
                </div>
                <div
                  className='flex-1 flex justify-center items-center rounded-[15px]'
                  style={{ backgroundColor: switchTags == 2 ? '#FFF' : '' }}
                  onClick={() => {
                    setSwitchTags(2)
                  }}
                >
                  <Image
                    src={switchTags == 2 ? '/images/gps/time-active.svg' : '/images/gps/time.svg'}
                    width={24}
                    height={24}
                    alt='date'
                  />
                </div>
              </div>
              {/* <div className={styles.period}>
            <span className={styles.periodText}>Date:</span>


          </div> */}
            </div>
          ) : null}

          <div className='lg:flex mt-[15px]'>
            {isMobile ? (switchTags == '2' ? GpsList() : null) : GpsList()}

            {isMobile && switchTags == '3' && (
              <div className='h-[calc(var(--vh2)*100-250px)] flex justify-center items-center px-[18px] pb-[18px]'>
                Application error: a client-side exception has occurred (see the browser console for more information).
              </div>
            )}

            {isMobile ? (
              switchTags == '1' ? (
                <div style={{ height: 'var(--vh2)*100', width: '100%' }} className=' gps-map'>
                  <div className='h-[58px] items-center flex w-full px-[14px] mx-auto'>
                    <div className='w-[30px] h-[30px] bg-[#edeff3] items-center flex rounded-full'>
                      <Image src='/images/gps/gps-active.svg' alt='gps' width={18} height={18} className='mx-auto' />
                    </div>
                    <div className='ml-[13px]'>
                      <p className='text-[#334062] text-[15px] font-[600]'>{mapdata && mapdata.position && mapdata.position}</p>
                    </div>
                  </div>
                  <div className='w-full h-[91%] p-[1px] GPS' id='leaflet'>
                    <div id='LeafletMap' style={{ height: '100%', width: '100%' }}></div>
                  </div>
                </div>
              ) : null
            ) : (
              <div style={{ height: 'var(--vh2)*100', width: '100%' }} className='Mlg:border-t-[1px]'>
                <div className='h-[60px] items-center flex w-full px-[14px] mx-auto'>
                  <div className='w-[40px] h-[40px] bg-[#edeff3] items-center flex rounded-full'>
                    <Icon icon='ic:baseline-location-on' width={20} height={20} className='mx-auto' />
                  </div>
                  <div className='ml-4'>
                    <p className='text-[#334062]  font-bold text-opacity-80'>{mapdata && mapdata.position && mapdata.position}</p>
                  </div>
                </div>

                <div className='w-full h-[calc(var(--vh2)*100-286px)] p-[1px] GPS' id='leaflet'>
                  <div id='LeafletMap' style={{ height: '100%', width: '100%' }}></div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Card>

      <Modal
        title=''
        open={preViewImageOpen}
        onCancel={() => {
          setPerViewImageOpen(false)
        }}
        width='540px'
        footer={[]}
        zIndex={1200}
      >
        <div style={{ padding: '14px' }}>
          <Image
            src={preViewImageUrl}
            width={200}
            height={200}
            style={{ width: '460px', height: 'auto' }}
            alt='preview'
          ></Image>
        </div>
      </Modal>
    </>
  )
}

export default GPS



// {
//   !Advanced ? (
//     <div className={styles.top}>
//       <div className={styles.device}>
//         <Select
//           className={styles.deviceSelect}
//           onChange={e => {
//             setPositiondata([])
//             setMapPositiondata([])

//             setSelectGeographicLocationId(e)
//             setPage(1)

//             advancedGps(0, 30)
//           }}
//           placeholder={t('current device')}
//           options={geographicLocation}
//         />
//       </div>
//       <div className={styles.date}>
//         <Image src='/images/locations/date.png' width={30} height={30} alt='date' className={styles.dateImg} />
//         {/* <DatePicker
//               placeholder={t('Select date')}
//               className={styles.datePic}
//               format='YYYY-MM-DD'
//               onChange={e => {
//                 setStartTime(dayjs(dayjs(e).format('YYYY-MM-DD 00:00:00')).unix() * 1000)
//                 setEndTime(dayjs(dayjs(e).format('YYYY-MM-DD 23:59:59')).unix() * 1000)
//                 setPositiondata([])
//                 setMapPositiondata([])
//               }}
//             /> */}
//       </div>
//       <div
//         className={styles.map}
//         style={{ backgroundColor: switchTags == 1 ? '#DFE1E6' : '' }}
//         onClick={() => {
//           setSwitchTags(1)
//         }}
//       >
//         <Image src='/images/locations/map.png' width={30} height={30} alt='date' />
//       </div>
//       <div
//         className={styles.time}
//         style={{ backgroundColor: switchTags == 2 ? '#DFE1E6' : '' }}
//         onClick={() => {
//           setSwitchTags(2)
//         }}
//       >
//         <Image src='/images/locations/time.png' width={30} height={30} alt='date' />
//       </div>
//       {/* <div className={styles.period}>
//             <span className={styles.periodText}>Date:</span>

//           </div> */}
//     </div>
//   ) : null
// }
